import { useState } from 'react';
import { fetchWithAuth } from '../Utils/fetchWithAuth'; 

export default function useDelete() {
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading]           = useState(false);
  const [error, setError]               = useState(null);

  const deleteData = async (url, dataToDelete = null) => {
    setLoading(true);
    setError(null);

    try {
      const options = {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      };

      if (dataToDelete) {
        options.body = JSON.stringify(dataToDelete);
      }

      const response = await fetchWithAuth(url, options);

      if (!response.ok) {
        throw new Error(`Errore nella richiesta: ${response.status}`);
      }

      const contentType = response.headers.get('content-type');
      let json = null;

      if (contentType && contentType.includes('application/json')) {
        json = await response.json();
        setResponseData(json);
      } else {
        setResponseData(null);
      }

      return json;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { responseData, loading, error, deleteData };
}
